package hxDaedalus.data.math;
class NodeData
{
    public var index : Int;
    public var point : Point2D;
    
    public function new()
    {
        
        
    }
}